import './bootstrap';
require('suggestags');